// extracted by mini-css-extract-plugin
export default {"component":"MessageViewbox_component__gsXU+","container":"MessageViewbox_container__OJLCo","progressContainer":"MessageViewbox_progressContainer__78Y2H"};